"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var base_1 = require("./base");
/**
 * 蓝主人API wrapper
 */
var BlueClient = /** @class */ (function (_super) {
    __extends(BlueClient, _super);
    function BlueClient(debug, blueConfig) {
        if (debug === void 0) { debug = true; }
        var _this = _super.call(this, debug) || this;
        _this.blueUrl = blueConfig.blueUrl;
        _this.secretKey = blueConfig.secretKey;
        return _this;
    }
    /**
     * 获取用户信息
     */
    BlueClient.prototype.getUserInfo = function (userId) {
        var url = this.blueUrl + "/Owner/" + userId;
        return this.get(url, { secret: this.secretKey });
    };
    return BlueClient;
}(base_1.BaseClient));
exports.BlueClient = BlueClient;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYmx1ZS1jbGllbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvY2xpZW50cy9ibHVlLWNsaWVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7QUFDQSwrQkFBb0M7QUFFcEM7O0dBRUc7QUFDSDtJQUFnQyw4QkFBVTtJQUl4QyxvQkFDRSxLQUFxQixFQUNyQixVQUdDO1FBSkQsc0JBQUEsRUFBQSxZQUFxQjtRQUR2QixZQU9FLGtCQUFNLEtBQUssQ0FBQyxTQUdiO1FBRkMsS0FBSSxDQUFDLE9BQU8sR0FBRyxVQUFVLENBQUMsT0FBTyxDQUFDO1FBQ2xDLEtBQUksQ0FBQyxTQUFTLEdBQUcsVUFBVSxDQUFDLFNBQVMsQ0FBQzs7SUFDeEMsQ0FBQztJQUVEOztPQUVHO0lBQ0ksZ0NBQVcsR0FBbEIsVUFBbUIsTUFBYztRQUMvQixJQUFNLEdBQUcsR0FBTSxJQUFJLENBQUMsT0FBTyxlQUFVLE1BQVEsQ0FBQztRQUM5QyxNQUFNLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxHQUFHLEVBQUUsRUFBRSxNQUFNLEVBQUUsSUFBSSxDQUFDLFNBQVMsRUFBRSxDQUFDLENBQUM7SUFDbkQsQ0FBQztJQUNILGlCQUFDO0FBQUQsQ0FBQyxBQXZCRCxDQUFnQyxpQkFBVSxHQXVCekM7QUF2QlksZ0NBQVUifQ==


//////////////////
// WEBPACK FOOTER
// ./node_modules/xbed-api/lib/clients/blue-client.js
// module id = 151
// module chunks = 44